import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import { AppPrepaidAutocomplete } from "@components"


export default function ReportPrepaidField() {
	const {
		filterIsPrepaid,
		setFilterIsPrepaidInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterIsPrepaid, "filterIsPrepaid", object({ filterIsPrepaid: string().nullable() }))

	return <AppPrepaidAutocomplete
		value={filterIsPrepaid}
		onChange={e => setFilterIsPrepaidInfo(e.target.value)}
		error={error}
	/>
}